import React from 'react';

/**
 * Shared table components for TableVirtuoso (Uploads, Exports tabs)
 */

export const LibraryTable: React.FC<React.ComponentProps<'table'>> = (props): JSX.Element => (
  <table
    {...props}
    style={{
      ...props.style,
      tableLayout: 'fixed',
      width: '100%',
      borderCollapse: 'collapse',
    }}
  />
);

interface LibraryTableRowProps extends React.ComponentProps<'tr'> {
  item?: unknown;
}

export const LibraryTableRow = React.forwardRef<HTMLTableRowElement, LibraryTableRowProps>(
  (props, ref): JSX.Element => {
    const { item, ...rest } = props;
    return (
      <tr {...rest} ref={ref} className="responsive-table-row uploads-table-row" />
    );
  },
);
